import { render, staticRenderFns } from "./SendBillingsMessageDialog.vue?vue&type=template&id=486f99f4&"
import script from "./SendBillingsMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SendBillingsMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendBillingsMessageDialog.vue?vue&type=style&index=0&id=486f99f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports